import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.101 3.291L16.709.898 17.107.5A1.692 1.692 0 1 1 19.5 2.892l-.399.399zm-3.49-1.297l2.392 2.393L11.5 10.89l-3.168.777.776-3.17 6.503-6.503zM3 3v11h3.5c.775 0 1.388.662 1.926 1.244l.026.028.085.091c.365.392.885.637 1.463.637.578 0 1.098-.245 1.463-.637a31 31 0 0 0 .102-.11l.009-.009C12.112 14.662 12.725 14 13.5 14H17v-3a1 1 0 1 1 2 0v6.5a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1H9a1 1 0 1 1 0 2H3z"
});

var SvgDraftOrdersMajor = function SvgDraftOrdersMajor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgDraftOrdersMajor as S };
